import { SearchSortKeys } from 'src/generated/product-service-graphql';
import { SORT_BY_KEY } from 'src/scripts/templates/product-listing-page/components/sorting-utils';

export function computeShopByColorConfig({ tags }: { tags?: string[] }) {
  const colorTagIndex = tags?.findIndex((tag) => tag.includes('Color:'));

  const colorTag = colorTagIndex !== undefined && tags?.[colorTagIndex];
  const genderId = tags
    ?.find((tag) => tag.includes('StyleId:'))
    ?.split(':')[1]
    ?.charAt(0);
  const gender = genderId === 'M' ? 'Men' : genderId === 'W' ? 'Women' : null;
  const sortBy = SearchSortKeys.BestSelling;
  const shopByColorURL = colorTag
    ? `/collections/color/${colorTag.toLowerCase().replace(/:|\s/g, '-')}${gender ? '?Gender=' + gender : ''}${
        `&${SORT_BY_KEY}=` + sortBy
      }`
    : null;
  return gender && colorTag && shopByColorURL ? { colorTag, gender, shopByColorURL } : null;
}

export type ShopByColorConfig = ReturnType<typeof computeShopByColorConfig>;
